var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66659 5.49998C1.66659 3.6539 3.14956 2.16665 4.96749 2.16665C5.77736 2.16665 6.52014 2.46097 7.09566 2.95172L6.28621 3.8286C6.04968 4.08483 6.23141 4.49991 6.58012 4.49992L9.26652 4.49997C9.48744 4.49998 9.66653 4.32089 9.66653 4.09998L9.66657 1.37726C9.66657 0.946385 9.1377 0.739593 8.84543 1.0562L8.00044 1.97158C7.18855 1.26338 6.1284 0.833313 4.96749 0.833313C2.40296 0.833313 0.333252 2.92778 0.333252 5.49998C0.333252 8.07218 2.40296 10.1666 4.96749 10.1666C7.07143 10.1666 8.84192 8.75644 9.41014 6.83159C9.51438 6.47846 9.31263 6.10769 8.9595 6.00345C8.60638 5.89921 8.23561 6.10096 8.13136 6.45409C7.72407 7.83379 6.45818 8.83331 4.96749 8.83331C3.14956 8.83331 1.66659 7.34606 1.66659 5.49998Z",
    fill: "#FF6170"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5e5cc6a42a0698e90b4bf0c21e299bff.svg";
export { ForwardRef as ReactComponent };